import { HeaderSidebar } from "../../../components/Header/HeaderSidebar"
import { Field, FieldArray, Form, Formik } from "formik"
import { useEffect, useRef, useState } from "react"
import { getClassName } from "../../../utils";
import { AddMore } from "../../../components/Buttons/AddMoreButton";
import { UpButton } from "../../../components/Buttons/UpButton";
import { DownButton } from "../../../components/Buttons/DownButton";
import { getLookForm } from "../../../services/autofillService";
import { useNavigate } from "react-router-dom";
import { Step } from "../../../components/Step/Step";
import { questions, videos } from "../../../content/personality/look";
import { useDispatch } from "react-redux";
import { setProgress } from "../../../store/progressSlice";
import { ProgressLine } from "../../../components/Progress/Line";
import { companionPersonalityLook } from "../../../services/companionService";
import Countdown from "react-countdown";
import { Buttons } from "../../../components/Stepper/StepperButtons";
import { Oval } from "react-loader-spinner";
import { submitLook } from "../../../services/answersService";
import { StepVideo } from "../../../components/Step/StepVideo";

export const PersonalityLook = () => {
    const [dateNow, setDateNow] = useState(Date.now());
    const dispatch = useDispatch()
    const timerRef = useRef(null);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [initialValues, setInitialValues] = useState({
        allLookAndFeelAttributes: [
            {
                lookAndFeelAttribute: "",
            },
            {
                lookAndFeelAttribute: "",
            },
            {
                lookAndFeelAttribute: "",
            },
            {
                lookAndFeelAttribute: "",
            },
            {
                lookAndFeelAttribute: "",
            },
            {
                lookAndFeelAttribute: "",
            },
        ],
        fiveLookAndFeelAttributes: [
            {
                lookAndFeelAttribute: "",
            },
            {
                lookAndFeelAttribute: "",
            },
            {
                lookAndFeelAttribute: "",
            },
            {
                lookAndFeelAttribute: "",
            },
            {
                lookAndFeelAttribute: "",
            },
        ],
        threeLookAndFeelAttributes: [
            {
                lookAndFeelAttribute: "",
            },
            {
                lookAndFeelAttribute: "",
            },
            {
                lookAndFeelAttribute: "",
            },
        ],
        companiesThatLookLikeThat1: [
            {
                company: "",
            },
            {
                company: "",
            },
        ],
        companiesThatLookLikeThat2: [
            {
                company: "",
            },
            {
                company: "",
            },
        ],
    });
    const [disabled, setDisabled] = useState(false);

    const handleSubmit = values => {
        setIsLoading(true);
        submitLook(values).then(response => {
            setIsLoading(false);
            navigate("/flow/personality/tone");
        }).catch(err => {
            setIsLoading(false)
            console.error(err);
        })
    }

    const handleUpClick = () => {
        setActiveStep(activeStep - 1)
        if (activeStep === 4) {
            dispatch(setProgress(66));
        } else if (activeStep === 3) {
            dispatch(setProgress(63));
        } else if (activeStep === 2) {
            dispatch(setProgress(60));
        } else if (activeStep === 1) {
            dispatch(setProgress(56));
        }
    }

    const handleDownClick = (values) => {
        setActiveStep(activeStep + 1);
        if (activeStep === 0) {
            dispatch(setProgress(60));
        } else if (activeStep === 1) {
            dispatch(setProgress(63));
        } else if (activeStep === 2) {
            dispatch(setProgress(66));
        } else if (activeStep === 3) {
            dispatch(setProgress(70));
        }
        if (activeStep + 1 === 3) {
            companionPersonalityLook(JSON.stringify(values.threeLookAndFeelAttributes)).then(response => {
                const data = response.data;
                console.log(data);
            }).catch(err => {
                console.error(err);
            })
        }
    }

    const countdownRenderer = ({  minutes, seconds, completed }) => {
        if (completed) {
            setDisabled(true);
        }
        if (seconds < 10) {
            return (
                <span className="has-yellow-text">
                    0{minutes} : 0{seconds}
                </span>
            );
        } else {
            return (
                <span className="has-yellow-text">
                    0{minutes} : {seconds}
                </span>
            );
        }
    }

    const fiveLookAndFeelAttributesInformation = (values) => (
        <div className="flex flex-col gap-2 flex-1">
            <p className="text-light-grey text-sm">All Look and Feel Attributes</p>
            <ul>
                {values.allLookAndFeelAttributes.map((el, index) => (
                    <li className="text-light-grey text-sm" key={index}>
                        {el.lookAndFeelAttribute}
                    </li>
                ))}
            </ul>
        </div>
    );

    const threeLookAndFeelAttributesInformation = values => (
        <div className="flex flex-col gap-2 flex-1">
            <p className="text-light-grey text-sm">Five Look and Feel Attributes</p>
            <ul>
                {values.fiveLookAndFeelAttributes.map((el, index) => (
                    <li className="text-light-grey text-sm" key={index}>
                        {el.lookAndFeelAttribute}
                    </li>
                ))}
            </ul>
        </div>
    )

    const handlePlay = () => {
        timerRef.current.pause();
    }

    const handlePause = () => {
        timerRef.current.start();
    }

    useEffect(() => {
        dispatch(setProgress(56))
        getLookForm().then(response => {
            const data = response.data;
            if (data) {
                setInitialValues(data);
            }
        }).catch(err => {
            console.error(err);
        })
    }, []);

    return (
        <>
            <ProgressLine />
            <section className="h-dvh overflow-hidden flex flex-col items-center justify-center">
                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched }) => (
                        <Form className="w-full max-w-[35%] h-full relative flex flex-col items-start justify-center">
                            <section className="flex flex-col items-center justify-center w-full h-full">
                                <StepVideo
                                    className={getClassName(0, activeStep)} question={questions.allLookAndFeelAttributes}
                                    url={videos.allLookAndFeelAttributesVideo.url}
                                    onPlay={handlePlay}
                                    onPause={handlePause}
                                >
                                    <Countdown
                                        ref={timerRef}
                                        date={dateNow + 5 * 60 * 1000}
                                        autoStart={false}
                                        renderer={countdownRenderer}
                                    />
                                    <FieldArray name="allLookAndFeelAttributes">
                                        {({ insert, remove, push }) => (
                                            <>
                                                {values.allLookAndFeelAttributes.length > 0 &&
                                                    values.allLookAndFeelAttributes.map((lookAndFeelAttribute, index) => (
                                                        <Field
                                                            name={`allLookAndFeelAttributes.${index}.lookAndFeelAttribute`}
                                                            placeholder="Adjective"
                                                            className="has-border-bottom mt-3"
                                                            key={index}
                                                            disabled={disabled}
                                                        />
                                                    ))
                                                }
                                                <AddMore onClick={() => push({ lookAndFeelAttribute: "" })} />
                                            </>
                                        )}
                                    </FieldArray>
                                </StepVideo>
                                <Step
                                    className={getClassName(1, activeStep)}
                                    question={questions.fiveLookAndFeelAttributes}
                                    url={videos.fiveLookAndFeelAttributesVideo.url}
                                    information={fiveLookAndFeelAttributesInformation(values)}
                                >
                                    <FieldArray name="fiveLookAndFeelAttributes">
                                        <>
                                            {values.fiveLookAndFeelAttributes.length > 0 &&
                                                values.fiveLookAndFeelAttributes.map((lookAndFeelAttribute, index) => (
                                                    <Field
                                                        name={`fiveLookAndFeelAttributes.${index}.lookAndFeelAttribute`}
                                                        placeholder="Adjective"
                                                        className="has-border-bottom mt-3"
                                                        key={index}
                                                    />
                                                ))}
                                        </>
                                    </FieldArray>
                                </Step>
                                <Step
                                    className={getClassName(2, activeStep)}
                                    question={questions.threeLookAndFeelAttributes}
                                    url={videos.threeLookAndFeelAttributesVideo.url}
                                    information={threeLookAndFeelAttributesInformation(values)}
                                >
                                    <FieldArray name="threeLookAndFeelAttributes">
                                        <>
                                            {values.threeLookAndFeelAttributes.length > 0 &&
                                                values.threeLookAndFeelAttributes.map((lookAndFeelAttribute, index) => (
                                                    <Field
                                                        name={`threeLookAndFeelAttributes.${index}.lookAndFeelAttribute`}
                                                        placeholder="Adjective"
                                                        className="has-border-bottom mt-3"
                                                        key={index}
                                                    />
                                                )
                                                )}
                                        </>
                                    </FieldArray>
                                </Step>
                                <Step className={getClassName(3, activeStep)} question={questions.companiesThatLookLikeThat1}>
                                    <FieldArray name="companiesThatLookLikeThat1">
                                        <>
                                            {values.companiesThatLookLikeThat1.length > 0 &&
                                                values.companiesThatLookLikeThat1.map(
                                                    (company, index) => (
                                                        <Field
                                                            name={`companiesThatLookLikeThat1.${index}.company`}
                                                            placeholder="Company"
                                                            className="has-border-bottom mt-3"
                                                            key={index}
                                                        />
                                                    )
                                                )}
                                        </>
                                    </FieldArray>
                                </Step>
                                <Step className={getClassName(4, activeStep)} question={questions.companiesThatLookLikeThat2}>
                                    <FieldArray name="companiesThatLookLikeThat2">
                                        <>
                                            {values.companiesThatLookLikeThat2.length > 0 &&
                                                values.companiesThatLookLikeThat2.map((company, index) => (
                                                    <Field
                                                        name={`companiesThatLookLikeThat2.${index}.company`}
                                                        placeholder="Brand or Celebrity"
                                                        className="has-border-bottom mt-3"
                                                        key={index}
                                                    />
                                                ))
                                            }
                                        </>
                                    </FieldArray>
                                </Step>
                            </section>
                            <Buttons link="/flow/personality/values">
                                <UpButton onClick={() => handleUpClick(values)} disabled={activeStep === 0} />
                                {(activeStep === 4) ? (
                                    <button type="submit" className="btn yellow-cta">
                                        {isLoading ? <Oval
                                            height={30}
                                            width={50}
                                            color="black"
                                            secondaryColor="black"
                                        /> : (
                                            <span>
                                                Next
                                            </span>
                                        )}
                                    </button>
                                ) : (
                                    <DownButton onClick={handleDownClick} disabled={activeStep === 4} />
                                )}
                            </Buttons>
                        </Form>
                    )}
                </Formik>
            </section>
            <HeaderSidebar activeEl="Personality & Charisma" />
        </>
    )
}